import { render, staticRenderFns } from "./employeeReg.vue?vue&type=template&id=7bffa3ea&scoped=true"
import script from "./employeeReg.vue?vue&type=script&lang=js"
export * from "./employeeReg.vue?vue&type=script&lang=js"
import style0 from "./employeeReg.vue?vue&type=style&index=0&id=7bffa3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bffa3ea",
  null
  
)

export default component.exports